import * as configureSolarApi from '../store/configureSolarApi';

const globalReducer = (state = {
    ...configureSolarApi.initialState
}, action) => {
    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default globalReducer;
